export default __webpack_public_path__ + "static/access_chicago-cbb3f15f22eb686309101e6f6c9973c3.webp";